import { Intent } from 'signup-constants/Intent';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { Step } from 'signup-constants/Step';
import { isIntent } from '../../utils/isIntent';
export const BranchMicroapps = {
  name: 'BranchMicroapps',
  stateCheck: () => {
    return isIntent(Intent.blogIdeasGenerator);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const stepsToRemove = [Step.CrmExperienceLevel];
    if (isIntent(Intent.blogIdeasGenerator)) {
      stepsToRemove.push(Step.CmsBusinessMaturity, Step.CmsSignupIntent);
    }
    return dispatch(FlowStateManager.removeSteps(stepsToRemove));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};